import { useCallback, useEffect, useState } from "react";

import Loading from "../../../../../../components/loading/Loading";
import { Table } from "../../../../../../components/table/Table";
import { api } from "../../../../../../services/api/api";
import toast from "react-hot-toast";
import { showApiErrorToast } from "../../../../../../services/api/error";
import EditCreateDrawer from "../../../../../../components/edit-create-drawer/EditCreateDrawer";
import TechnicianTimeTypeForm from "../../../../../../components/data/time-type/TechnicianTimeTypeForm";
import TechnicianTimeTypeListItem from "../../../../../../components/data/time-type/TechnicianTimeTypeListItem";

/**
* AdminTechnicianTimeTypesTab: Admin technician time types tab
*/
export default function AdminTechnicianTimeTypesTab() {
  const [types, setTypes] = useState<EasyTech.TimeType[] | null>(null);

  const TABLE_HEAD = [
    {
      label: "Label",
      orderKey: "label"
    },{
      label: "Visibility",
      orderKey: "visibility"
    }, {
      label: "actions",
      orderKey: null
    }
  ];

  /**
  * createType: create technician time type
  * @param type - time type data to create
  */
  const createType = (type: EasyTech.TimeType): Promise<void> => {
    return new Promise((resolve, reject) => {
      if (type.translations) {
        type.translations = type.translations.filter((el: EasyTech.Translation) => {
          const cond = !el.label;
          return !cond;
        });
      }
      if (type && type.label) {
        // Format the data for the API
        const formattedData = {
          label: type.label,
          visibility: type.visibility || "ALL",
          translations: type.translations?.map((translation: any) => ({
            language: {
              id: translation.language.id
            },
            label: translation.label,
            isDefault: false
          })) || []
        };

        api.post("admin/technician_time_types", formattedData).then((ret) => {
          loadTechnicianTimeTypes();
          toast.success("Technician time type created");
          return resolve();
        }).catch((error) => {
          console.error(error);
          showApiErrorToast(error, { fallbackMessage: "Erreur lors de la création du type d'indisponibilité" });
          return reject();
        });
      } else {
        toast.error("Form is invalid");
        return reject();
      }
    });
  };
  /***/

  /**
  * loadTechnicianTimeTypes: load technician time types
  */
  const loadTechnicianTimeTypes = useCallback(() => {
    api.get("admin/technician_time_types").then((ret) => {
      const tmp =  (ret as EasyTech.TimeType[]).filter((el) => el.label !== "Intervention");
      setTypes(tmp);
    }).catch((err) => {
      console.error(err);
      setTypes([]);
    });
  }, []);

  /**
  * useEffect: get technician time types list on init
  */
  useEffect(() => {
    loadTechnicianTimeTypes();
  }, [loadTechnicianTimeTypes]);
  /***/

  return (
    <div>
      <div className="icon-buttons flex gap-2">
        <EditCreateDrawer data={({translations: [] as EasyTech.Translation[], visibility: "ALL"} as EasyTech.TimeType)}
                                  entityName="Technician time type"
                                  FormComponent={TechnicianTimeTypeForm}
                                  isNotEditable={true}
                                  onSubmit={createType}
                                  createButtonText="Create new Technician time type" />
      </div>

      <div className="my-6">
        {types ?
          <Table  tableHead={TABLE_HEAD}
                  emptyTable={(!types || types.length === 0) ? "No time types" : false}>
            {types.map((type, index) => (
              <TechnicianTimeTypeListItem key={type.id+"-"+index} type={type} isLast={index === types.length - 1} onChange={loadTechnicianTimeTypes} />
            ))}
          </Table>
        : <Loading/>}
      </div>

    </div>
  );
}
